package models

import kotlinx.serialization.Serializable

@Serializable
data class TransactionContext(
    val id: String,
    val userId: String,
    val name: String,
    val color: String,
    val createdAt: String = "",
    val updatedAt: String = ""
)

object ContextColorPalette {
    val colors: List<String> get() = utils.CategoryUtils.colorPalette

    fun nextColor(usedColors: List<String>): String {
        val unused = colors.filter { it !in usedColors }
        return if (unused.isNotEmpty()) unused.first()
        else colors[usedColors.size % colors.size]
    }
}
